import { createListenerMiddleware } from '@reduxjs/toolkit';
import { addCollectionListener } from '@/entities/collection';
import { addAuthListener } from '@/entities/session';

export const listenerMiddleware = createListenerMiddleware();

addAuthListener(listenerMiddleware.startListening);
addCollectionListener(listenerMiddleware.startListening);

export type AppStartListening = typeof listenerMiddleware.startListening;
